import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IndexColorPipe } from './index-color.pipe';
import { IndexValuePipe } from './index-value.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IndexColorPipe,
    IndexValuePipe
  ],
  exports: [
    IndexColorPipe,
    IndexValuePipe
  ]
})
export class PipesModule { }
